var _ellipse, _ellipse2, _path, _path2, _path3, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavigationPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 65,
    viewBox: "0 0 44 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 55,
    rx: 16,
    ry: 10,
    fill: "white"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22,
    cy: 55,
    rx: 13,
    ry: 8,
    fill: "#00BCEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7899 45.0092L16.7873 45.006C14.5805 42.2601 12.1378 40.282 10.5256 38.9765C10.2938 38.7888 10.0791 38.6149 9.88483 38.4548C5.00625 34.3982 0.942034 28.6949 0.942034 21.9807C0.942034 10.8928 10.358 1.81635 22.024 1.81635C33.69 1.81635 43.1059 10.8928 43.1059 21.9807C43.1059 28.6949 39.0417 34.3982 34.1632 38.4548C33.9688 38.6149 33.7542 38.7888 33.5224 38.9765C31.9102 40.282 29.4675 42.2601 27.2606 45.006L27.2581 45.0092C25.8894 46.7283 24.5786 48.518 23.5089 50.1966C22.9442 51.0827 22.4377 51.9517 22.024 52.7729C21.6103 51.9517 21.1038 51.0827 20.5391 50.1966C19.4694 48.518 18.1585 46.7283 16.7899 45.0092Z",
    fill: "url(#paint0_linear_10001_5223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7899 45.0092L16.7873 45.006C14.5805 42.2601 12.1378 40.282 10.5256 38.9765C10.2938 38.7888 10.0791 38.6149 9.88483 38.4548C5.00625 34.3982 0.942034 28.6949 0.942034 21.9807C0.942034 10.8928 10.358 1.81635 22.024 1.81635C33.69 1.81635 43.1059 10.8928 43.1059 21.9807C43.1059 28.6949 39.0417 34.3982 34.1632 38.4548C33.9688 38.6149 33.7542 38.7888 33.5224 38.9765C31.9102 40.282 29.4675 42.2601 27.2606 45.006L27.2581 45.0092C25.8894 46.7283 24.5786 48.518 23.5089 50.1966C22.9442 51.0827 22.4377 51.9517 22.024 52.7729C21.6103 51.9517 21.1038 51.0827 20.5391 50.1966C19.4694 48.518 18.1585 46.7283 16.7899 45.0092Z",
    stroke: "#081E3D",
    strokeWidth: 1.78804
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7899 45.0092L16.7873 45.006C14.5805 42.2601 12.1378 40.282 10.5256 38.9765C10.2938 38.7888 10.0791 38.6149 9.88483 38.4548C5.00625 34.3982 0.942034 28.6949 0.942034 21.9807C0.942034 10.8928 10.358 1.81635 22.024 1.81635C33.69 1.81635 43.1059 10.8928 43.1059 21.9807C43.1059 28.6949 39.0417 34.3982 34.1632 38.4548C33.9688 38.6149 33.7542 38.7888 33.5224 38.9765C31.9102 40.282 29.4675 42.2601 27.2606 45.006L27.2581 45.0092C25.8894 46.7283 24.5786 48.518 23.5089 50.1966C22.9442 51.0827 22.4377 51.9517 22.024 52.7729C21.6103 51.9517 21.1038 51.0827 20.5391 50.1966C19.4694 48.518 18.1585 46.7283 16.7899 45.0092Z",
    stroke: "white",
    strokeWidth: 1.78804
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.0205,
    cy: 22.1094,
    r: 10.3518,
    fill: "url(#paint1_linear_10001_5223)",
    stroke: "white",
    strokeWidth: 0.627384
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10001_5223",
    x1: 22.0238,
    y1: 0.922363,
    x2: 22.0238,
    y2: 55.0775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D274D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D274D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10001_5223",
    x1: 22.0205,
    y1: 11.4438,
    x2: 22.0205,
    y2: 32.7749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71FF31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00BCEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationPin);
export default __webpack_public_path__ + "static/media/navigation-pin.367949f8f54e22042a38b304fac21991.svg";
export { ForwardRef as ReactComponent };